import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import { postApiFormData } from "../../helpers/AxiosInstance";
import Button from "../Reusable/Button";
import LocalCombobox from "../Reusable/LocalCombobox";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import ComboboxInput from "../Reusable/ComboboxInput";
import ACCOUNTS from "../../constant/Accounts";

const Setting = ({ data }) => {
  const {
    formState: { errors },
    setError,
    setValue,
    handleSubmit,
    clearErrors,
    register,
    getValues,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        default_sales_account: data?.default_sales_account,
        default_purchase_account: data?.default_purchase_account,
        date_type: data?.date_type,
        type: {
          id: data?.type,
          name: data?.type,
        },
      };
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const CompanyTypeData = [
    { id: "Service", name: "Service" },
    { id: "Trading", name: "Trading" },
    { id: "Manufacturing", name: "Manufacturing" },
  ];

  const handleChangeSetting = async (values: any, setError: any) => {
    setIsLoading(true);
    const url = `${APIS.COMPANY_PROFILE}update/`;
    const formData = new FormData();
    formData.append("default_sales_account", values?.default_sales_account);
    formData.append(
      "default_purchase_account",
      values?.default_purchase_account
    );
    formData.append("type", values?.type);
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 200) {
        toast.success("Update Successfully");
        queryClient.invalidateQueries({
          queryKey: ["company-profile"],
          refetchType: "active",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => handleChangeSetting(data, setError))}
        className={tw`px-4`}
      >
        <div className={tw`grid grid-cols-3 gap-x-4`}>
          <ComboboxInput
            url={APIS.COA}
            queryKey={"sales-account"}
            register={register("default_sales_account")}
            errors={errors?.default_sales_account}
            name={"default_sales_account"}
            label={"Default Sales Account"}
            setValue={setValue}
            props={{
              parent: ACCOUNTS.DIRECT_INCOME_ID,
            }}
            getValues={getValues}
            placeholder={"Search... "}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.COA}
            queryKey={"purchase-account"}
            register={register("default_purchase_account")}
            errors={errors?.default_purchase_account}
            name={"default_purchase_account"}
            label={"Default Purchase Account"}
            setValue={setValue}
            props={{
              parent: ACCOUNTS.DIRECT_EXPENSES_ID,
            }}
            getValues={getValues}
            placeholder={"Search... "}
            clearErrors={clearErrors}
          />
          <LocalCombobox
            data={CompanyTypeData}
            errors={errors?.type}
            setValue={setValue}
            label={"Business Nature"}
            name={"type"}
            clearErrors={clearErrors}
            value={getValues("type")}
          />
        </div>
        <div className={tw`w-full flex justify-end`}>
          <div className={tw`w-24`}>
            <Button label="Save" isLoading={isLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default Setting;
